import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button, Form } from "react-bootstrap";
import AdminHeader from "../../common/AdminHeader";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const Taluka = () => {
  const [talukas, setTalukas] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formState, setFormState] = useState({
    id: 0,
    districtID: 0,
    name: "",
  });
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    fetchTalukas();
    fetchDistricts();
  }, []);

  const fetchTalukas = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/TalukaMaster`);
      setTalukas(response.data);
    } catch (error) {
      toast.error("Failed to fetch talukas.");
    }
  };

  const fetchDistricts = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/DistrictMaster`);
      setDistricts(response.data);
    } catch (error) {
      toast.error("Failed to fetch districts.");
    }
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormState({ id: 0, districtID: 0, name: "" });
    setEditMode(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  };

  const handleEdit = (taluka) => {
    setFormState(taluka);
    setEditMode(true);
    handleShowModal();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this taluka?")) {
      try {
        await axios.delete(`${baseUrl}/api/TalukaMaster/${id}`);
        toast.success("Taluka deleted successfully.");
        fetchTalukas();
      } catch (error) {
        toast.error("Failed to delete taluka.");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formState.districtID === 0) {
        toast.error("Please select a District.");
        return;
      }
    try {
      if (editMode) {
        await axios.put(`${baseUrl}/api/TalukaMaster/${formState.id}`, formState);
        toast.success("Taluka updated successfully.");
      } else {
        await axios.post(`${baseUrl}/api/TalukaMaster`, formState);
        toast.success("Taluka added successfully.");
      }
      fetchTalukas();
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to save taluka.");
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Taluka</h2>
          <Button variant="primary" onClick={handleShowModal}>
            Add Taluka
          </Button>
        </div>

        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
            <th>#</th>      
            <th>Taluka Name</th>
              <th>District</th>              
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {talukas.map((taluka, index) => (
              <tr key={taluka.id}>
                 <td>{index + 1}</td>     
                 <td>{taluka.name}</td>      
                <td>{districts.find((district) => district.id === taluka.districtID)?.name}</td>
                
                <td>
                  <Button variant="warning" onClick={() => handleEdit(taluka)}>
                    Edit
                  </Button>{" "}
                  <Button variant="danger" onClick={() => handleDelete(taluka.id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? "Edit Taluka" : "Add Taluka"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>District</Form.Label>
              <Form.Control
                as="select"
                name="districtID"
                value={formState.districtID}
                onChange={handleInputChange}
                required
              >
                <option value="0">Select District</option>
                {districts.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Taluka Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formState.name}
                onChange={handleInputChange}
                required
              />
            </Form.Group>          
          </Form>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="primary" type="submit" onClick={(e) => handleSubmit(e)}>
              {editMode ? "Update" : "Add"}
            </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
         
        </Modal.Footer>
      </Modal>

      <ToastContainer />

      <Footer />
    </>
  );
};

export default Taluka;
